// @noflow
import i18next from 'i18next'
import upperFirst from 'lodash/upperFirst'
import React from 'react'

import { possessive } from '@/utils/StringHelper'

import Text from '@/components/elements/atoms/Text/Text'
import { CardCallout } from '@/components/elements/molecules/CardCallout'
import { DogAvatar } from '@/components/elements/molecules/DogAvatar'

import STYLES from './MultipleDogsCallout.module.sass'

import type {
  EditDailyAmountQuery_user_dogs as Dog,
  EditDailyAmountQuery_user_subscription_plan as Plan
} from '../../queries/__generated__/EditDailyAmountQuery'

import { LargestPlanNotification } from '../LargestPlanNotification'

type Props = {
  dogs: Array<Dog>
  chosenPlan: Plan | null
}

const MultipleDogsCallout = ({
  dogs: dogsData,
  chosenPlan
}: Props): React.JSX.Element | null => {
  const dogs =
    chosenPlan?.portioningForDogs.map((portioningForDog) => ({
      ...portioningForDog,
      ...dogsData?.find(({ id }) => id === portioningForDog.dogId)
    })) ?? []

  const commonTextProps = {
    namespace: 'account',
    margin: false
  }

  return (
    <CardCallout show={(dogs && dogs?.length > 1) ?? false}>
      <div
        className={STYLES.wrapper}
        data-testid="multiple-dogs-callout-card-wrapper"
      >
        {dogs.map((dog) => (
          <div
            key={dog.id}
            className={STYLES.content}
            data-testid="multiple-dogs-callout-card-content"
          >
            <DogAvatar
              variant="dynamic"
              avatarUrl={dog.dogProfile?.avatarUrl}
              ageInMonths={dog.ageInMonths ?? 0}
              image={{
                width: 64,
                height: 64
              }}
            />
            <div className={STYLES.textWrapper}>
              <Text
                text="edit_daily_amount.multiple_dogs_callout.title"
                variables={{
                  possessiveDogName: possessive(
                    upperFirst(dog.name),
                    i18next.language
                  )
                }}
                {...commonTextProps}
              />
              <div>
                <Text
                  text="edit_daily_amount.multiple_dogs_callout.amount"
                  variant="display20"
                  variables={{ gramsPerDay: dog.portionInGrams }}
                  {...commonTextProps}
                />
                <Text
                  text="edit_daily_amount.multiple_dogs_callout.calories"
                  variables={{ calories: dog.roundedPortionInCalories }}
                  {...commonTextProps}
                />
              </div>
            </div>
          </div>
        ))}
        <LargestPlanNotification chosenPlan={chosenPlan} />
      </div>
    </CardCallout>
  )
}

export { MultipleDogsCallout }
